'use client';

import { ViewTransition } from 'react';

import { useTranslations } from 'next-intl';

import { LoadingPage } from '@/components/loading-page';

export const LoadingPageMessage = () => {
  const t = useTranslations('loading');

  return (
    <ViewTransition default="none" exit="loading-exit">
      <LoadingPage message={t('loading')} variant="fullPage" />
    </ViewTransition>
  );
};
